import React from 'react'
import { useEffect } from "react";
import { sendMessageApi } from '../lib/api'
import { useRouter } from 'next/router'

export default function FormBottom({siteEnv, isContact = false}) {
  
  const router = useRouter();

  var erreur;
  const sendMessage = async (e) => {
      erreur = '';
      e.preventDefault()
      /* console.log(siteEnv, site)
      return; */
      console.log(e.target.name.value);
      const result = await sendMessageApi(e.target, siteEnv);
      console.log('result', result);
      if (result['envoyé']) {
          router.push('/contact-success');
      } else {
          if (result['erreur']) {
              erreur = result['erreur'];
          } else {
              erreur = 'Erreur lors de l\'envoi du message.';
          }
          document.getElementById('erreur').innerHTML = erreur;
      }
  }

  return (
    
    <section id="zone7" className="bg-color-orange py-24 lg:py-32 relative z-30">
      <div className="container mx-auto px-4 h-full">
        <div className="grid gap-4 grid-cols-12 items-center h-full">
          <div className="col-span-12 md:col-span-6 md:col-start-4">
              {isContact? 
              (<h1 className="text-5xl text-white mb-6 text-center font-light">Vous souhaitez travailler<br/> avec nous ?</h1>) 
              :
              (<p className="text-5xl text-white mb-6 text-center">Vous souhaitez travailler<br/> avec nous ?</p>)
              }
              <form onSubmit={sendMessage} /* method="post" id="monForm" action="/contact" */>
                <div className="flex w-full gap-4">
                  <div className="md:w-1/2 w-full">
                    <div>
                      <label htmlFor="name" className="color-white"></label>
                      <input name="name" type="text" className="input-user bg-color-transparent placeholder-white w-full mb-2 color-white border border-white p-2" placeholder="Nom"  required="" />
                    </div>
                    <div>
                      <label htmlFor="email"></label>
                      <input name="email" type="text" className="input-mail bg-color-transparent placeholder-white w-full mb-2 color-white border border-white p-2" placeholder="Email"  required="" />
                    </div>
                    <div>
                      <label htmlFor="tel"></label>
                      <input name="tel" type="text" className="input-phone bg-color-transparent placeholder-white w-full mb-2 color-white border border-white p-2" placeholder="Téléphone"  required="" />
                    </div>
                  </div>
                  <div className="md:w-1/2 w-full">
                    <div>
                      <label htmlFor="message"></label>
                      <textarea name="message" className="text-form bg-color-transparent w-full color-white border placeholder-white border-white p-2 mb-2" placeholder="Votre message" required=""></textarea>
                    </div>
                    <div className="flex items-center">
                      <input type="submit" name="submit" id="submit" className="bg-color-transparent text-white w-auto color-white border border-white transition duration-500 ease-in-out hover:bg-white hover:text-color-primary px-6 py-2" value="Envoyer" required="" />
                      <span className="w-full"><hr className="contact-hr white"/></span>
                    </div>
                  </div>
                </div> 
              </form>
          </div>
        </div>
      </div>
    </section>

  )
}